import React from 'react'
import { ICSModal } from '../../components'
import { ModalBody } from 'reactstrap'

const areEqual = (prevProps, nextProps) => {
    return prevProps.visible === nextProps.visible;
};

const Help = React.memo((
  props: React.PropsWithChildren<{
    visible: boolean
    onHiding: () => void
    width?: number | string
    height?: number | string
    title?: string
  }>
)=> {
  return (
    <ICSModal
      visible={props.visible}
      onHiding={props.onHiding}
      dragEnabled={false}
      closeOnOutsideClick={true}
      title={props.title ? props.title : 'Help'}
      defaultWidth={props.width ? props.width : '50vw'}
      defaultHeight={props.height ? props.height : '50vh'}
    >
      <ModalBody>
        {props.children}
      </ModalBody>
    </ICSModal>
  )
},areEqual)

export default Help
